import React, { useEffect } from "react";
import Sparkles from "./Sparkles";

// Fixed golden radiant backdrop + cursor-follow gold glow.
export default function GoldenBackground() {
  useEffect(() => {
    let raf = null;
    const onMove = (e) => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        document.documentElement.style.setProperty("--mx", `${e.clientX}px`);
        document.documentElement.style.setProperty("--my", `${e.clientY}px`);
        raf = null;
      });
    };
    window.addEventListener("pointermove", onMove);
    return () => {
      window.removeEventListener("pointermove", onMove);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <>
      <div className="aurora" aria-hidden="true">
        <div className="aurora__rays" />
        <div className="aurora__glow" />
        <div className="aurora__core" />
        <div className="aurora__orb aurora__orb--a" />
        <div className="aurora__orb aurora__orb--b" />
        <Sparkles count={24} />
      </div>
      <div className="cursor-glow" aria-hidden="true" />
    </>
  );
}
